import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { OperatorWorkspaceRouteGate } from '@/components/operator/operator-workspace-route-gate'
import { PlacesEditor } from '@/components/operator/places-editor'
import { useOperatorConfiguration } from '@/lib/operator-config/use-operator-configuration'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/locations')({
  component: PlacesPage,
  staticData: {
    breadcrumbs: [{ label: 'Locations' }],
  } satisfies RouteStaticData,
})

function PlacesPage() {
  const { configuration, isLoading, error, refreshAll } = useOperatorConfiguration()

  return (
    <WorkspaceRouteShell>
      <OperatorWorkspaceRouteGate
        configuration={configuration}
        isLoading={isLoading}
        error={error}
        onRetry={refreshAll}
        loadingCopy="Loading locations…"
        resourceLabel="locations"
        noOperatorTitle="Set up your business before adding locations."
        noOperatorDescription="Finish setup first so saved locations can be reused in availability and service area rules."
      >
        <PlacesEditor configuration={configuration} onSaved={refreshAll} />
      </OperatorWorkspaceRouteGate>
    </WorkspaceRouteShell>
  )
}
